jQuery( document ).ready(function( $ ) {
  $('.simple-collection:not(.product-recommendations) .product-container, .product-container-slick, .gallery.section-standard .grid, .logo-list .product-container-slick').slick({
  	infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
  });
  
  $('.gallery.section-standard .grid, .gallery.section-standard .grid-gutterless').slick({
  	infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
  	autoplaySpeed: 2000,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  });
	
});
